import { pxToRem } from "./utils";

export const typography = {
  jumbo: {
    _1: {
      fontFamily: "Manrope",
      fontSize: pxToRem(45),
      fontWeight: 700,
      letterSpacing: "0px",
      lineHeight: 1,
    },
    _2: {
      fontFamily: "Manrope",
      fontSize: pxToRem(38),
      fontWeight: 700,
      letterSpacing: "0px",
      lineHeight: 1.1579,
    },
    _3: {
      fontFamily: "Manrope",
      fontSize: pxToRem(32),
      fontWeight: 700,
      letterSpacing: "0px",
      lineHeight: 1.125,
    },
    _4: {
      fontFamily: "Manrope",
      fontSize: pxToRem(24),
      fontWeight: 700,
      letterSpacing: "0px",
      lineHeight: 1.25,
    },
    _5: {
      fontFamily: "Manrope",
      fontSize: pxToRem(18),
      fontWeight: 700,
      letterSpacing: "0px",
      lineHeight: 1.3333,
    },
  },
  title: {
    _1: {
      fontFamily: "Manrope",
      fontSize: pxToRem(24),
      fontWeight: 500,
      letterSpacing: "0px",
      lineHeight: 0,
    },
    _2: {
      fontFamily: "Manrope",
      fontSize: pxToRem(20),
      fontWeight: 500,
      letterSpacing: "0px",
      lineHeight: 0,
    },
    _3: {
      fontFamily: "Manrope",
      fontSize: pxToRem(18),
      fontWeight: 500,
      letterSpacing: "0px",
      lineHeight: 0,
    },
  },
  label: {
    _1: {
      fontFamily: "Manrope",
      fontSize: pxToRem(16),
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: 1.5,
    },
    _2: {
      fontFamily: "Manrope",
      fontSize: pxToRem(14),
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: 1.5714,
    },
    _3: {
      fontFamily: "Manrope",
      fontSize: pxToRem(12),
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: 1.5833,
    },
    _4: {
      fontFamily: "Manrope",
      fontSize: pxToRem(10),
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: 1.6,
    },
  },
  paragraph: {
    _1: {
      fontFamily: "Manrope",
      fontSize: pxToRem(16),
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: 1.5,
    },
    _2: {
      fontFamily: "Manrope",
      fontSize: pxToRem(14),
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: 1.5714,
    },
    _3: {
      fontFamily: "Manrope",
      fontSize: pxToRem(12),
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: 1.5833,
    },
    _4: {
      fontFamily: "Manrope",
      fontSize: pxToRem(10),
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: 1.6,
    },
  },
  overline: {
    _1: {
      fontFamily: "Manrope",
      fontSize: pxToRem(16),
      fontWeight: 800,
      letterSpacing: pxToRem(0.8),
      lineHeight: 1.5,
    },
    _2: {
      fontFamily: "Manrope",
      fontSize: pxToRem(14),
      fontWeight: 800,
      letterSpacing: pxToRem(0.7),
      lineHeight: 1.5714,
    },
    _3: {
      fontFamily: "Manrope",
      fontSize: pxToRem(12),
      fontWeight: 800,
      letterSpacing: pxToRem(0.6),
      lineHeight: 1.5833,
    },
    _4: {
      fontFamily: "Manrope",
      fontSize: pxToRem(10),
      fontWeight: 800,
      letterSpacing: pxToRem(0.5),
      lineHeight: 1.6,
    },
  },
  book: {
    title: {
      _0_25: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "28px",
        fontWeight: 700,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _0_5: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "26px",
        fontWeight: 700,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _1: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "24px",
        fontWeight: 700,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _2: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "20px",
        fontWeight: 700,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _3: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "18px",
        fontWeight: 700,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _4: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "16px",
        fontWeight: 700,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _5: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "14px",
        fontWeight: 700,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _6: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _7: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "11px",
        fontWeight: 700,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
    },
    label: {
      _0_125: {
        color: "#3D3B33",
        fontFamily: "Literata",
        fontSize: "22px",
        fontWeight: 600,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _0_25: {
        color: "#3D3B33",
        fontFamily: "Literata",
        fontSize: "20px",
        fontWeight: 600,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _0_50: {
        color: "#3D3B33",
        fontFamily: "Literata",
        fontSize: "18px",
        fontWeight: 600,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _1: {
        color: "#3D3B33",
        fontFamily: "Literata",
        fontSize: "16px",
        fontWeight: 600,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _2: {
        color: "#3D3B33",
        fontFamily: "Literata",
        fontSize: "14px",
        fontWeight: 600,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _3: {
        color: "#3D3B33",
        fontFamily: "Literata",
        fontSize: "12px",
        fontWeight: 600,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _4: {
        color: "#3D3B33",
        fontFamily: "Literata",
        fontSize: "10px",
        fontWeight: 600,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
    },
    paragraph: {
      _0_5: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "18px",
        fontWeight: 400,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _1: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "16px",
        fontWeight: 400,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _2: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "14px",
        fontWeight: 400,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _3: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "12px",
        fontWeight: 400,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _3_5: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "11px",
        fontWeight: 400,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
      _4: {
        color: "#22211C",
        fontFamily: "Literata",
        fontSize: "10px",
        fontWeight: 400,
        letterSpacing: "0px",
        lineHeight: 1.5,
      },
    },
    overline: {
      _1: {
        color: "#494C5C",
        fontFamily: "Literata",
        fontSize: "16px",
        fontWeight: 700,
        letterSpacing: "0.8px",
        lineHeight: 1.2,
      },
      _2: {
        color: "#494C5C",
        fontFamily: "Literata",
        fontSize: "14px",
        fontWeight: 700,
        letterSpacing: "0.7px",
        lineHeight: 1.2,
      },
      _3: {
        color: "#494C5C",
        fontFamily: "Literata",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.6px",
        lineHeight: 1.2,
      },
      _4: {
        color: "#494C5C",
        fontFamily: "Literata",
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "0.5px",
        lineHeight: 1.2,
      },
      _5: {
        color: "#494C5C",
        fontFamily: "Literata",
        fontSize: "8px",
        fontWeight: 700,
        letterSpacing: "0.4px",
        lineHeight: 1.2,
      },
    },
  },
};
